
import { Vue, Component, Watch } from 'vue-property-decorator';
import { warkLabel } from '@/models/wark';
import WorkbenchesService from '@/services/workbenches.service';
import lazyInject from '@/di';
import moment from 'moment';
import { getCurrentMonth } from '@/common/utils';
import { AuthEnum } from '@/services/permission.service';
// import { BigNumber } from 'bignumber.js';
import { Decimal } from 'decimal.js';


@Component({})
export default class PromotionCompletionRate extends Vue {
  columns = warkLabel.init('PromotionCompletionRate');

  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  AuthEnum = AuthEnum;

  type: any = '';

  moment = moment;

  pagination: any = {
    current: 1,
    pageSize: 10,
    onChange: this.handleChangePage,
  };

  form: any = {
    dept_id: undefined,
    group_id: undefined,
    month: '',
  };
  dept_list: any = [];
  group_list: any[] = [];

  dataList = [
  ];

  module: any = '';
  @Watch('$route.query')
  handleQuery() {
    const { dept_id, recharge, group_id, month, page, pageSize, type, module } = this.$route.query;
    const query: any = {
      page: page || 1,
      pageSize: pageSize || 10,
    };
    if (dept_id) {
      query.dept_id = dept_id;
      this.form.dept_id = +dept_id;
    }
    if (recharge) {
      query.recharge = recharge;
      this.form.recharge = recharge;
    }
    if (group_id) {
      query.group_id = group_id;
      this.form.group_id = +group_id;
    }
    if (month) {
      query.month = month;
      this.form.month = month;
    } else {
      query.month = getCurrentMonth();
      this.form.month = getCurrentMonth();
    }
    if (type) {
      this.type = type;
    }
    if (module) {
      this.module = module;
      query.module = module;
    }
    this.getQuickEntrance(query);
  }

  async getDeptInfo() {
    const res = await this.workbenchesService.getDeptInfo();
    this.dept_list = res;
    const { dept_id } = this.$route.query;
    if (!dept_id) return;
    const deptId = Number(dept_id);
    this.group_list = this.dept_list.find((item: any) => item.dept.id === deptId).group;
  }
  selectOption(val: any) {
    this.group_list = this.dept_list.find((res: any) => res.dept.id === val).group;
    this.form.group_id = undefined;
  }
  async getQuickEntrance(query: any) {
    const res = await this.workbenchesService.getQuickEntrance(query);
    let _data: any = res;
    if (query.dept_id) {
      _data = res.filter((item: any) => {
        return item.dept_id === +query.dept_id;
      });
    }
    if (query.group_id) {
      _data = res.filter((item: any) => {
        return item.group_id === +query.group_id;
      });
    }
    this.func(_data);
  }

  func(data: any) {
    const dataSource = data;
    const _data = data.map((item: any) => dataSourceForEach(item));
    Decimal.set({ precision: 20 });
    function dataSourceForEach(item: any) {
      const _item: any = item;
      let monthTarget: any = 0; let monthCompleted: any = 0; let monthCompletedRate: any = 0;
      dataSource.forEach((rem: any) => {
        if (item.dept_id === rem.dept_id) {
          const a = new Decimal(rem.target_quota);
          const _a = new Decimal(monthTarget);
          const b = new Decimal(rem.month_real_price);
          const _b = new Decimal(monthCompleted);
          monthTarget = _a.plus(a);
          monthCompleted = _b.plus(b);
          monthCompletedRate = `${((monthCompleted / monthTarget) * 100).toFixed(2)}%`;
        }
      });
      let groupTarget: any = 0;
      let groupCompleted: any = 0;
      let groupCompletedRate: any = 0;
      dataSource.forEach((rem: any) => {
        if (item.group_id === rem.group_id) {
          const a = new Decimal(rem.target_quota);
          const _a = new Decimal(groupTarget);
          const b = new Decimal(rem.month_real_price);
          const _b = new Decimal(groupCompleted);
          groupTarget = _a.plus(a);
          groupCompleted = _b.plus(b);
          groupCompletedRate = `${((groupCompleted / groupTarget) * 100).toFixed(2)}%`;
        }
      });
      _item.monthTarget = monthTarget.toFixed(2);
      _item.monthCompleted = monthCompleted.toFixed(2);
      _item.monthCompletedRate = monthCompletedRate;
      _item.groupTarget = groupTarget.toFixed(2);
      _item.groupCompleted = groupCompleted.toFixed(2);
      _item.groupCompletedRate = groupCompletedRate;
      return _item;
    }
    this.dataList = _data;
  }
  handleChangePage(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getQuery();
  }
  changeColumns() {
    const obj: any = {
      dept_name: 'dept_id',
      dept_leader: 'dept_id',
      monthTarget: 'dept_id',
      monthCompleted: 'dept_id',
      monthCompletedRate: 'dept_id',
      group_leader: 'group_id',
      groupTarget: 'group_id',
      groupCompleted: 'group_id',
      groupCompletedRate: 'group_id',
      group_name: 'group_id',
    };
    this.columns.forEach((res: any) => {
      if (Object.prototype.hasOwnProperty.call(obj, res.dataIndex)) {
        res.customRender = (text: any, row: any, index: any) => {
          return this.customRender(text, row, index, obj[res.dataIndex]);
        };
      }
    });
  }

  async exportData() {
    const queryParams: any = {
      module: this.module,
      export: 1,
    };
    const { month, dept_id, group_id } = this.form;
    if (month) {
      queryParams.month = month;
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
    }
    if (group_id) {
      queryParams.group_id = group_id;
    }
    await this.workbenchesService.getQuickEntranceExport(queryParams, '推广通消耗完成率');
  }

  tableRowClassName() {
    return 'tableRowClassName';
  }
  customRender(text: any, row: any, index: any, column: any) {
    const prevRow: any = this.dataList[index - 1];
    if (prevRow && prevRow[column] === row[column]) {
      return {
        children: text,
        attrs: {
          rowSpan: 0,
        },
      };
    }
    let rowSpan = 1;
    const _i: number = index;
    for (let i = _i + 1; i < this.dataList.length; i++) {
      const currentRow: any = this.dataList[i];
      if (currentRow[column] === row[column]) {
        rowSpan++;
      } else {
        break;
      }
    }
    return {
      children: text,
      attrs: {
        rowSpan,
      },
    };
  }
  refresh() {
  }
  handleChangeMonth(date: any) {
    this.form.month = moment(date).format('YYYY-MM');
  }
  handleClick(record: any) {
    const { dept_id, group_id, month } = this.form;
    const _text = {
      dept_id,
      group_id,
      month,
      type: this.type,
      module: this.module,
    };
    // const url: any = this.$router.resolve({
    //   name: 'workbenches.ConsumptionDetails',
    //   query: {
    //     group_id: record.group_id,
    //     dept_id: record.dept_id,
    //     agentName: record.username,
    //     month: this.form.month,
    //     old_query: JSON.stringify(_text),
    //   },
    // });
    // window.open(url.href, '_blank');
    this.$router.push({
      name: 'workbenches.ConsumptionDetails',
      query: {
        group_id: record.group_id,
        dept_id: record.dept_id,
        agentName: record.username,
        month: this.form.month,
        old_query: JSON.stringify(_text),
      },
    });
  }
  search() {
    this.getQuery();
  }
  getQuery() {
    const { month, dept_id, group_id } = this.form;
    const { current, pageSize } = this.pagination;

    const query: any = {
      page: current,
      pageSize,
      type: this.type,
      module: this.module,
    };
    query.timestamp = Math.round(Date.now() / 1000);
    if (month) {
      query.month = month;
    }
    if (dept_id) {
      query.dept_id = dept_id;
    }
    if (group_id) {
      query.group_id = group_id;
    }
    this.$router.push({
      query,
    });
  }
  reset() {
    this.form = {};
    this.pagination.current = 1;
    const query: any = {
      type: this.type,
      module: this.module,
    };
    query.timestamp = Math.round(Date.now() / 1000);
    query.month = getCurrentMonth();
    this.$router.push({
      query,
    });
  }

  handleClickTarget() {
    const { dept_id, group_id, month } = this.form;
    const _text = {
      dept_id,
      group_id,
      month,
      type: this.type,
      module: this.module,
    };
    this.$router.push({
      name: 'workbenches.TargetConsumptionManagement',
      query: {
        old_query: JSON.stringify(_text),
      },
    });

    // const url: any = this.$router.resolve({
    //   name: 'workbenches.TargetConsumptionManagement',

    // });
    // window.open(url.href, '_blank');
  }
  back() {
    this.$router.push({
      name: 'workbenches.index',
    });
  }


  mounted() {
    const { type, module } = this.$route.query;
    this.type = type;
    this.module = module;
    const action: any = {
      title: '查看',
      dataIndex: 'action',
      scopedSlots: { customRender: 'action' },
      align: 'center',
      width: 150,
    };
    this.changeColumns();

    switch (this.type) {
      case 'director':
        // this.columns = this.columns.slice(4);
        action.fixed = 'right';
        this.columns.push(action);
        break;
      case 'assistantDirector':
        // this.columns = this.columns.slice(4);
        action.fixed = 'right';
        this.columns.push(action);
        break;
      case 'ordinaryTeamMinister':
        this.columns = this.columns.slice(2);
        action.fixed = 'right';
        this.columns.push(action);
        break;
      case 'kaTeamMinister':
        this.columns = this.columns.slice(2);
        action.fixed = 'right';
        this.columns.push(action);
        break;
      case 'kaTeamLeader':
        this.columns = this.columns.slice(5);
        action.fixed = 'right';
        this.columns.push(action);
        break;
      case 'ordinaryTeamLeader':
        this.columns = this.columns.slice(5);
        action.fixed = 'right';
        this.columns.push(action);
        break;
      case 'ordinaryTeam':
        this.columns = this.columns.slice(8);
        this.columns.push(action);
        break;
      case 'kaTeam':
        this.columns = this.columns.slice(8);
        this.columns.push(action);
        break;
      default: {
        return null;
      }
    }
    this.getDeptInfo();
    this.handleQuery();
  }
}
